import React from 'react';
import styled from "@emotion/styled";
import {Box, BoxContainer} from "../styles/BoxStyles";
import {CallToAction} from "../styles/CommonStyler";
import sv from "../styles/styles";
import {useTranslation} from "react-i18next";


const Heading = styled('div')`
    ${sv.h2}
    margin-bottom: 16px;
`;

const Faq = styled('div')`
    max-width: 800px;
    margin-bottom: 16px;
`;

const FaqTitle = styled('h3')`
    ${sv.h3}
`;

const FaqContent = styled('div')`
    text-align: start;
    padding: 16px;
    margin-left: 16px;
    
    @media(max-width: 450px) {
        padding: 16px 5px;
        margin-left: 5px;
    }
`;

const Button = styled(CallToAction)`
    background-color: ${sv.colors.cta};
    border: none;
`;

const FaqBox = styled(Box)`
    margin: 0;
`;

export function FaqSection() {
    const {t} = useTranslation("faq_section");

    return <BoxContainer>
        <FaqBox maxWidth="none">
            <Heading>{t("FAQs")}</Heading>
            <Faq>
                <FaqTitle>{t("What is Gistify?")}</FaqTitle>
                <FaqContent>{t("what_is_gist_desc")}</FaqContent>
            </Faq>
            <Faq>
                <FaqTitle>{t("How can I use Gistify?")}</FaqTitle>
                <FaqContent>{t("how-use_gist_desc")}</FaqContent>
            </Faq>
            <Button onClick={() => window.location.replace('/faq')}>{t("Learn More")}</Button>
        </FaqBox>
    </BoxContainer>;
}